import { render, staticRenderFns } from "./SuperAdminCreateOperatorItem.vue?vue&type=template&id=08e7898d&functional=true&lang=pug"
var script = {}
import style0 from "./SuperAdminCreateOperatorItem.vue?vue&type=style&index=0&id=08e7898d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports